<script>
import {defineComponent, reactive} from 'vue';
import fuzzysort from 'fuzzysort';
import PoliticiansAppGroup from './PoliticiansAppGroup.vue';
import Multiselect from '@vueform/multiselect';

const DATASET = window.LBRL_FPOLIT || [];

const initialStyle = window.innerWidth > window.LBRL_HEADERS?.mbhThreshold ? 'cards' : 'list';

export default defineComponent({
    name: 'PoliticiansApp',

    components: { PoliticiansAppGroup, Multiselect },

    props: {
        title: {
            type: String,
            default: '',
        },
        showSearch: {
            type: [Boolean, Number],
            default: true,
        },
        ids: {
            type: Array,
            default: () => [],
        },
        categoryIds: {
            type: Array,
            default: () => [],
        },
        inclAdministrativeLevels: {
            type: Array,
            default: () => [],
        },
        link: { type: Object },
    },

    data() {
        const preFilteredGroups = DATASET.filter(group => {
            return group.level === 'current' || this.inclAdministrativeLevels.includes(group.level);
        }).map(group => {
            return Object.assign({}, group, {
                people: group.people.filter(p => {
                    let ret = true;
                    if (this.ids.length) {
                        ret = this.ids.includes(p.id);
                    }
                    if (ret && this.categoryIds.length) {
                        ret = p.cat.some(catId => this.categoryIds.includes(catId));
                    }
                    return ret;
                }),
            });
        });
        const categoryGroups = preFilteredGroups.map((group, idx) => {
            return {
                label: group.label,
                options: group.categories.map(cat => {
                    return { label: cat.name, value: cat.id };
                }),
            };
        });
        return {
            groups: preFilteredGroups,
            resultsStyle: initialStyle,
            categoryGroups,
            selectedCategories: [],
            searchStr: '',
            searchStatus: 0,
        };
    },

    methods: {
        toggleCat(catName) {
            if (catName) {
                if (this.selectedCategories.includes(catName)) {
                    this.selectedCategories = this.selectedCategories.filter(c => c !== catName);
                } else {
                    this.selectedCategories = this.selectedCategories.concat(catName);
                }
            } else {
                this.selectedCategories = [];
            }
        },
    },
});
</script>


<template>
    <div class="fpolit">

        <div v-if="title" class="container container-narrow">
            <h2 class="fpolit-extraTitle">{{ title }}</h2>
        </div>

        <div v-if="showSearch" class="fpolit-ctrl">
            <div class="container container--narrow">
                <div class="fpolit-ctrlSearch">
                    <label>
                        <input ref="searchInput" type="text" v-model="searchStr" placeholder="Sök här"/>
                        <span class="icon icon-magnifying-glass"></span>
                    </label>
                </div>
                <div class="fpolit-ctrlFilter">
                    <div class="fpolit-filterPicker">
                        <h2>
                            <span>Kategori</span>
                            <button @click="selectedCategories = []" v-if="selectedCategories.length">Återställ</button>
                        </h2>
                        <div>
                            <Multiselect
                                v-model="selectedCategories"
                                mode="tags"
                                groups="true"
                                :options="categoryGroups"
                                :searchable="true"
                                :close-on-select="false"
                                placeholder="Alla"
                            />
                        </div>
                    </div>
                    <div class="fpolit-viewPicker">
                        <h2>&nbsp;</h2>
                        <div class="fpolit-viewPicker-views">
                            <button
                                class="fpolit-ctrlBtn for--listView"
                                :class="{'is--active': resultsStyle === 'list'}"
                                @click="resultsStyle = 'list'"
                            >
                                <span></span><span></span><span></span>
                            </button>
                            <button
                                class="fpolit-ctrlBtn for--cardView"
                                :class="{'is--active': resultsStyle === 'cards'}"
                                @click="resultsStyle = 'cards'"
                            >
                                <span></span><span></span><span></span><span></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PoliticiansAppGroup
            v-for="group in groups"
            :key="group.label"
            :group="group"
            :allGroups="groups"
            :showSearch="showSearch"
            :searchStr="searchStr"
            :selectedCategories="selectedCategories"
            :resultsStyle="resultsStyle"
        />

        <div class="container">
            <div v-if="link" class="fpolit-extraLinkWrapper">
                <a class="lbrl-btn" :href="link.url" :target="link.target">{{ link.title }}</a>
            </div>
        </div>

    </div>
</template>
